module.exports = __webpack_public_path__ + "media/images/niq-open-a1cfada4491169bf55b3f3a6bb56df3c.svg";